import { FileHelper } from '@/helpers/file.helper';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CompaniesService, PhotosService, UsersService } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-img-display',
    templateUrl: './img-display.component.html',
    styleUrls: ['./img-display.component.scss'],
    standalone: true,
    imports: [NgIf, MatProgressSpinnerModule]
})
export class ImgDisplayComponent implements OnInit, OnDestroy, OnChanges {
  @Input() uid = '';
  @Input() imageTs: string;
  @Input() hasBorder = false;
  @Input() showNoImage = true;
  @Input() reload = 0;
  @Input() type: 'companyLogo' | 'propertyPhoto' | 'userAvatar' | 'url';
  @Input() size: string = null;
  @Input() url: string = null;

  readonly NO_IMAGE_TEXT = "Pas d'image";

  getImageSub = new Subscription();
  isLoading = false;
  file: Blob | null;
  image: SafeUrl;
  noImageDisplayText = this.NO_IMAGE_TEXT;

  imageCss: string;
  imageClass: string;

  constructor(
    private companiesService: CompaniesService,
    private photosService: PhotosService,
    private usersService: UsersService,
    private sanitizer: DomSanitizer,
    private fileHelper: FileHelper
  ) {}

  ngOnInit(): void {
    this.imageClass = 'image-display';
    if (this.type === 'userAvatar') {
      this.imageClass += ' user-avatar';
    }
    this.imageCss = this.size
      ? 'object-fit: cover; width: ' + this.size.split('x')[0] + 'px; height: ' + this.size.split('x')[1] + 'px;'
      : '';
    this.getImage();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.reload?.currentValue) {
      this.getImage();
    }
  }

  ngOnDestroy(): void {
    this.getImageSub.unsubscribe();
  }

  getImage() {
    switch (this.type) {
      case 'companyLogo':
        this.getCompanyLogo();
        break;
      case 'propertyPhoto':
        this.getPropertyPhoto();
        break;
      case 'userAvatar':
        this.getUserAvatar();
        break;
      case 'url':
        this.image = this.url;
        break;
      default:
        console.error('DEV: il manque un appel API');
        this.noImageDisplayText = 'DEV: il manque un appel API';
        break;
    }
  }

  // ---------------------------------------- //
  //                   APIS                   //
  // ---------------------------------------- //
  getCompanyLogo() {
    this.isLoading = true;
    this.getImageSub = this.companiesService.getCompanyLogo(this.uid, this.imageTs).subscribe({
      next: (file: Blob) => {
        this.isLoading = false;
        this.file = file;
        this.image = this.fileHelper.imageApiToHtml(file);
      },
      error: (err: any) => {
        this.isLoading = false;
      }
    });
  }

  getPropertyPhoto() {
    this.isLoading = true;
    this.getImageSub = this.photosService.getMainPhotoImage(this.uid, this.size, this.imageTs).subscribe({
      next: (file: Blob) => {
        this.isLoading = false;
        this.file = file;
        this.image = this.fileHelper.imageApiToHtml(file);
      },
      error: (err: any) => {
        this.isLoading = false;
      }
    });
  }

  getUserAvatar() {
    this.isLoading = true;
    this.getImageSub = this.usersService.getUserAvatar(this.uid, this.imageTs).subscribe({
      next: (file: Blob) => {
        this.isLoading = false;
        this.file = file;
        this.image = this.fileHelper.imageApiToHtml(file);
      },
      error: (err: any) => {
        this.isLoading = false;
      }
    });
  }
}
